import PropTypes from 'prop-types'
import Link from 'next/link'

// Internal components
import LazyImage from '../LazyImage/LazyImage'

const LinkBlock = (props) => {
  const { thumbnail, title, description, internalUrl, modifiers, slug, url } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  const thumbnailObject = Object.assign({}, thumbnail?.[0])
  const internalUrlObject = Object.assign({}, internalUrl?.[0])

  let href = null
  href = internalUrlObject.uri || slug ? slug || `/${internalUrlObject.uri}` : url

  return (
    <>
      {href ? (
        <>
          <Link href={href}>
            <a className={`LinkBlock${modifierClasses}`}>
              {thumbnailObject.image && (
                <div className="LinkBlock-figure">
                  <LazyImage
                    {...thumbnailObject}
                    alt={thumbnailObject.alt}
                    sizes={'(min-width: 1580px) 360px, (min-width: 760px) 33vw, (min-width: 1024px) 25vw, 100vw'}
                  />
                </div>
              )}
              <div className="LinkBlock-text">
                <h3 className="LinkBlock-title">{title}</h3>
                {description && <p className="LinkBlock-description">{description}</p>}
              </div>
            </a>
          </Link>
        </>
      ) : (
        <>
          <a className={`LinkBlock LinkBlock--empty${modifierClasses}`}>
            {thumbnailObject.image && (
              <div className="LinkBlock-figure">
                <LazyImage
                  {...thumbnailObject}
                  alt={thumbnailObject.alt}
                  sizes={'(min-width: 1580px) 360px, (min-width: 760px) 33vw, (min-width: 1024px) 25vw, 100vw'}
                />
              </div>
            )}
            <div className="LinkBlock-text">
              <h3 className="LinkBlock-title">{title}</h3>
              {description && <p className="LinkBlock-description">{description}</p>}
            </div>
          </a>
        </>
      )}
    </>
  )
}

LinkBlock.propTypes = {
  thumbnail: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  modifiers: PropTypes.array,
  internalUrl: PropTypes.array,
  slug: PropTypes.string,
  url: PropTypes.string
}

export default LinkBlock
